// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul,
li {
      margin: 0;
      padding: 0;
      list-style: none;
}

#file-label {
      display: inline-flex;
      vertical-align: middle;
      font-size: 12px;
      line-height: 18px;
}

#file-label mat-icon {
      font-size: 18px;
      text-align: center;
}

#file-label a {
      cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/material-file-upload/fileupload.component.css"],"names":[],"mappings":"AAAA;;MAEM,SAAS;MACT,UAAU;MACV,gBAAgB;AACtB;;AAEA;MACM,oBAAoB;MACpB,sBAAsB;MACtB,eAAe;MACf,iBAAiB;AACvB;;AAEA;MACM,eAAe;MACf,kBAAkB;AACxB;;AAEA;MACM,eAAe;AACrB","sourcesContent":["ul,\nli {\n      margin: 0;\n      padding: 0;\n      list-style: none;\n}\n\n#file-label {\n      display: inline-flex;\n      vertical-align: middle;\n      font-size: 12px;\n      line-height: 18px;\n}\n\n#file-label mat-icon {\n      font-size: 18px;\n      text-align: center;\n}\n\n#file-label a {\n      cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
